import makeStyles from '@mui/styles/makeStyles';
import bgExperiencer from '../../../assets/images/home.webp';

export const useStyles = makeStyles((theme) => ({
    container: {
        padding: `80px 60px 80px 100px`,
        backgroundColor: theme.palette.colors.white,
        [theme.breakpoints.down('md')]: {
            padding: `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(6)}`,
        },
    },
    gridContainer: {
        [theme.breakpoints.up('md')]: {
            background: `linear-gradient(
        rgba(255, 255, 255, 0.60), 
        rgba(255, 255, 255, 0.55)
      ), url(${bgExperiencer}) no-repeat center center local`,
            backgroundSize: 'cover',
        },
    },
    experiencerDataContainer: {
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    title: {
        height: theme.spacing(4),
    },
    profile: {
        backgroundColor: 'rgb(0 68 142 / 18%)',
        color: 'rgb(0,68,142)',
    },
    newExperienceButton: {
        marginLeft: '10px',
        float: 'right',
        cursor: 'pointer',
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'none',
        backgroundColor: 'var(--color-utriper-blue)',
        '&:hover': {
            backgroundColor: 'var(--color-utriper-blue-dark)',
        },
    },
    newBookingButton: {
        float: 'right',
        cursor: 'pointer',
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'none',
        backgroundColor: '#333',
        '&:hover': {
            backgroundColor: '#454545',
        },
    },

    toggleExperiencesButton: {
        float: 'right',
        cursor: 'pointer',
        fontSize: '8px',
        marginTop: '15px',
        color: 'white',
        fontWeight: 'bold',
        width: 'fit-content',
        boxSizing: 'fit-content',
        backgroundColor: '#333',
        '&:hover': {
            backgroundColor: '#454545',
        },
    },
}));
